/**
 * LashyFans homepage: scroll reveal + stagger (no deps, vanilla JS)
 */
(function () {
  function runReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
          function show() {
            el.classList.add('is-visible');
          }
          if (delay) setTimeout(show, delay);
          else show();
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runReveal);
  else runReveal();
})();
